import {useMemo} from 'react';
import type {
  ContentLabelWithLayout,
  EventNameVariantFieldLayout,
} from 'components/fields/types';
import {mapValues} from 'services/utils';
import type {EventNameVariantExtraField as ExtraField} from '../components/types';
import {useLabelsAndPlaceholders} from './useLabelsAndPlaceholders';

export const useEventNameVariantLabelsAndPlaceholders = (
  extraField: ExtraField | undefined,
  fieldLayout: EventNameVariantFieldLayout,
): {
  contentLabels: ContentLabelWithLayout[];
  fieldLayoutWithPlaceholders: EventNameVariantFieldLayout;
} => {
  const labelsAndPlaceholders = useLabelsAndPlaceholders([
    'name',
    'description',
  ]);

  return useMemo(() => {
    const requiredFields = ['name'];
    const labelKeys: (keyof EventNameVariantFieldLayout)[] = ['name'];
    if (extraField) labelKeys.push(extraField);
    labelKeys.push('mainForm');

    return {
      // Content labels only for selected fields
      contentLabels: labelKeys.map(key => ({
        ...fieldLayout[key],
        label:
          key !== 'mainForm' ? labelsAndPlaceholders[key].label : undefined,
        required: requiredFields.includes(key),
      })),
      fieldLayoutWithPlaceholders: mapValues(fieldLayout, (value, key) => ({
        ...value,
        placeholder:
          key !== 'mainForm'
            ? labelsAndPlaceholders[key].placeholder
            : undefined,
      })),
    };
  }, [extraField, fieldLayout, labelsAndPlaceholders]);
};
